// jquery-ui's base theme CSS is not imported here any more. It styled the
// widgets the legacy search field created at runtime (.autocomplete(),
// .selectmenu(), .slider()); this brand renders the Stimulus search field,
// and the only code still creating those widgets is the separate iframe
// pack, which imports the theme itself. fixtravel/supremecard keep theirs
// -- they are out of the rebuild's scope.
import "themes/general/desktop";
import "themes/flysmarter/desktop";

import "components/desktop/cookie";
import "components/common/funnel_tracking_boot";

import "../../dep/google_analytics/desktop_triggers";
import "../../dep/skyscanner/desktop_triggers";

// Rebuild (redesign/rebuild-*): Tailwind + Turbo + Stimulus, loaded last so
// the unlayered reset block in tailwind.css wins source-order ties against
// the legacy theme imports above -- see that file for why.
import "../../styles/tokens/flysmarter.css";
import "../../styles/tailwind.css";
import "@hotwired/turbo-rails";
import "../../controllers";
